/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAlertConditionGroupFromJSON, ApiAlertConditionGroupToJSON, } from './ApiAlertConditionGroup';
import { ApiAlertRequirementPeriodFromJSON, ApiAlertRequirementPeriodToJSON, } from './ApiAlertRequirementPeriod';
import { ApiChartFromJSON, ApiChartToJSON, } from './ApiChart';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiAlertRequirementFromJSON(json) {
    return ApiAlertRequirementFromJSONTyped(json, false);
}
export function ApiAlertRequirementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'alertId': !exists(json, 'alertId') ? undefined : json['alertId'],
        'chart': !exists(json, 'chart') ? undefined : ApiChartFromJSON(json['chart']),
        'chartId': !exists(json, 'chartId') ? undefined : json['chartId'],
        'chartLastNDays': !exists(json, 'chartLastNDays') ? undefined : json['chartLastNDays'],
        'conditionGroups': !exists(json, 'conditionGroups') ? undefined : (json['conditionGroups'].map(ApiAlertConditionGroupFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'period': !exists(json, 'period') ? undefined : ApiAlertRequirementPeriodFromJSON(json['period']),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
    };
}
export function ApiAlertRequirementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'alertId': value.alertId,
        'chart': ApiChartToJSON(value.chart),
        'chartId': value.chartId,
        'chartLastNDays': value.chartLastNDays,
        'conditionGroups': value.conditionGroups === undefined ? undefined : (value.conditionGroups.map(ApiAlertConditionGroupToJSON)),
        'id': value.id,
        'period': ApiAlertRequirementPeriodToJSON(value.period),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
    };
}
